import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { forkJoin } from "rxjs";
import { ServiceRoleComponent } from "../../../../../components/pages/roles/components/service/service-role.component";
import {Bot} from "../../../../../models/bot";
import { Role } from "../../../../../models/role";
import {BotControllerService} from "../../../../../services/role-controller/bot-controller.service";
import { RoleControllerService } from "../../../../../services/role-controller/role-controller.service";
import { RoleService } from "../../../../../services/role-controller/role.service";
import { BaseError } from "../../../base-error";

@Component({
    selector: "role-bot-selector",
    templateUrl: "./role-bot-selector.component.html",
    providers: [BotControllerService, RoleControllerService],
})

export class RoleBotSelectorComponent extends BaseError implements OnInit {

    public role: Role;
    public botId: string;
    public serviceId: string;

    public baseUrl: string;
    public searchedCat: string;
    public searchedType: string;
    public selectedId: string;
    public availableBots: Bot[];
    public bots: Bot[];
    public selectedBot: Bot;

    public isLoading = false;
    public activeTab: string = "general";

    constructor(private botController: BotControllerService,
                private roleController: RoleControllerService,
                private roleService: RoleService,
                private router: Router,
                private route: ActivatedRoute, toastr: ToastrService) {
        super(toastr);
    }

    @ViewChild(ServiceRoleComponent) public serviceRoleComponent: ServiceRoleComponent;

    public ngOnInit() {
        this.reloadBot();
    }

    public reloadBot() {
        this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
            this.botId = params.botId;
            this.botController.getBot(this.botId).subscribe(
                (data) => this.selectedBot = data,
            );
        });
    }

    public filterType(event) {
        if (this.searchedType) {
            if (this.searchedCat) { this.searchedCat = ""; }
            if (this.selectedBot) { this.selectedBot = null; }
            if (this.selectedId) { this.selectedId = ""; }
            this.availableBots = this.bots.filter((b) => b.botType === this.searchedType);
        }
    }

    public filterCat(event) {
        if (this.selectedBot) { this.selectedBot = null; }
        if (this.selectedId) { this.selectedId = ""; }
        if (this.searchedCat) { this.availableBots = this.bots.filter((b) => b.category === this.searchedCat); }
    }

    public selectBot(event) {
        this.setSelectedBot(this.selectedId);
    }

    public addNewBot() {
        this.selectedId = "";
        this.selectedBot = new Bot();
        this.selectedBot.category = this.searchedCat;
        this.selectedBot.botType = this.searchedType;
        // this.updateRole(this.role);
    }

    public updateSelector(): void {
        this.getRolesList();
    }

    public addedNewBot(data) {
        this.selectedId = data.id;
        this.selectedBot = data;
        this.bots.push(data);
        this.availableBots.push(data);
        this.role.bot = data.id;
    }

    public setSelectedBot(bId) {
        if (bId) {
            this.selectedBot = this.bots.find((r) => r.id === bId);
            this.searchedType = this.selectedBot.botType;
            this.searchedCat = this.selectedBot.category;
            this.role.bot = bId;
        }
    }

    public updatedRole() {
        this.serviceRoleComponent.resetMapping();
      }

    public getRolesList() {
        this.botController.getServiceBots(this.serviceId).subscribe(
            (data) => {
                this.availableBots = this.bots = data;
                if (this.role.bot) {
                    this.selectedId = this.role.bot.id;
                    this.setSelectedBot(this.selectedId);
                } else {
                    this.selectedId = "";
                    this.selectedBot = null;
                    this.searchedType = "";
                    this.searchedCat = "";
                }
            },
        );
    }

    public notifyTabChange(tab) {
        this.activeTab = tab;
        // notify child component
        this.serviceRoleComponent.togglePanel(this.activeTab === "bot-service");
    }

}
